import { useMutation } from '@tanstack/react-query';
import { ViewerApi } from 'Data/Viewer.api';
import { ViewerEngineEnum } from 'Data/enums/ViewerEngine';
import { nativeLog } from 'Utils/nativeViewerLog';

interface IRenderViewerFileRequest {
  constructionSiteId: number;
  fileApiId: string;
  /** Ausente = Autodesk. */
  engine?: ViewerEngineEnum;
}

// Render com a resposta em mãos. Não passa pela saga do Autodesk de propósito:
// o nativo não consome a cota de conversões da Autodesk que a saga contabiliza,
// e quem chama precisa da resposta para decidir o próximo passo.
export const useQueryRenderViewerFile = () => {
  return useMutation({
    mutationFn: async ({ constructionSiteId, fileApiId, engine }: IRenderViewerFileRequest) => {
      nativeLog('render → POST /Viewer/Render', { constructionSiteId, fileApiId, engine });
      try {
        const { data } = await ViewerApi.renderViewerFile({
          constructionSiteId,
          fileApiId,
          folderId: '',
          engine,
        });
        // Resposta crua: é aqui que se vê se o backend aceitou o nativo
        // (`engine: 'native'`) ou rebaixou para a Autodesk (sem `engine`).
        nativeLog('render ←', data);
        return data.data;
      } catch (err) {
        nativeLog('render ✗', err);
        throw err;
      }
    },
  });
};
